var map = {
	"./Calgary.jpg": 2474,
	"./Edmonton.jpg": 2175,
	"./Kelowna.jpg": 5851,
	"./London.jpg": 4283,
	"./Montreal.jpg": 7464,
	"./Ottawa.jpg": 513,
	"./Québec.jpg": 8571,
	"./Toronto.jpg": 991,
	"./Vancouver.jpg": 9181,
	"./Victoria.jpg": 3604,
	"./Waterloo.jpg": 6665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3616;